// @module Anchorgroup.GridCartAdder.GridCartAdderMod
define('Anchorgroup.GridCartAdder.GridCartAdderMod.View'
	, [
		'anchorgroup_gridcartadder_gridcartaddermod.tpl'
		, 'Utils'
		, 'Backbone'
		, 'jQuery'
		, 'underscore'
		, 'LiveOrder.Model'
	]
	, function (
		anchorgroup_gridcartadder_gridcartaddermod_tpl
		, Utils
		, Backbone
		, jQuery
		, _
		, LiveOrderModel
	) {
		'use strict';
		var self

		return Backbone.View.extend({

			template: anchorgroup_gridcartadder_gridcartaddermod_tpl,
			contextDataRequest: ['item']

			, initialize: function (options) {
				var self = this;
				this.cart = options.Cart;
				this.quantity = 0;

				this.updateQuantity();

				// this.cartModel = LiveOrderModel.getInstance();
				// this.cartModel.on('change', function (model) {
				// 	var changedBySelf = model.get('changedBySelf');
				// 	if (changedBySelf) {
				// 		model.unset('changedBySelf', 'silent');
				// 		console.log(model);
				// 	} else {
				// 		self.updateQuantity();
				// 	}		
				// });

				this.itemId = options.itemId;
				//console.log(this.itemId);
			},

			updateQuantity: function () {
				var self = this;
				self.cart.getLines().then(function (lines) {
					//console.log(lines, lines.length);

					var cartIDArray = [];
					for (var i = 0; i < lines.length; i++) {
						var itemID = lines[i]['item']['internalid'];

						cartIDArray.push(itemID);
					}

					//console.log('cartIDArray: ', cartIDArray);
					var itemIDMatch = cartIDArray.indexOf(self.itemId);
					//console.log('itemIDMatch: ', itemIDMatch);
					if (itemIDMatch >= 0) {
						var lineMatch = _.filter(lines, function (line) {
							//console.log('line', line);
							return line.item.internalid == self.itemId;
						});

						self.quantity = lineMatch[0].quantity;
						//console.log('amountFormatted', self.amountFormatted)
						self.render();
					}
				});
			},

			subtotalFormatAndSetter: function (subtotalDiv) {
				var decimalRegex = /[.]/;
				var currencyRegex = /[\$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/

				var decimalValidation = decimalRegex.test(subtotalAmount);
				//console.log('decimalValidation: ', decimalValidation);
				var currencyValidation = currencyRegex.test(subtotalAmount);
				//console.log('currencyValidation: ', currencyValidation);


				if (currencyValidation == false && decimalValidation == false) {
					jQuery(subtotalDiv).text('$' + subtotalAmount + '.00');

				} else if (currencyValidation == false && decimalValidation == true) {
					jQuery(subtotalDiv).text('$' + subtotalAmount);

				} else if (currencyValidation == true && decimalValidation == false) {
					jQuery(subtotalDiv).text(subtotalAmount + '.00');

				} else {
					jQuery(subtotalDiv).text(subtotalAmount);
				}
			}


			, events: {
				'change [data-type="quantity-input"]': 'changeQuantity'
			}

			, changeQuantity: _.debounce(function (e) {
				//console.log("triggered");
				// this.cartModel.set("changedBySelf", true);
				// console.log(this.cartModel);


				//I) Get current item and quantity
				//console.log('changeQty', e);
				var itemID = e.target.id.split('-').pop().trim();
				//console.log('itemID: ', itemID);
				//console.log(document.getElementById('quantity-' + itemID).value);
				var itemQuantity = document.getElementById('quantity-' + itemID).value/1;
				//console.log('itemQuantity: ', itemQuantity);


				// II) Check if it's in the cart or not and get line ID
				var Cart = this.options.container.getComponent('Cart');
				var lineAlreadyExists = false;

				Cart.getLines().then(function (lines) {
					//console.log(lines, lines.length);
					for (var i = 0; i < lines.length; i++) {

						if (lines[i]['item']['internalid'] == itemID) {
							lineAlreadyExists = true;

							var lineID = lines[i]['internalid'];
							//console.log('lineID: ', lineID);

						}

						//III A) IF ALREADY IN THE CART, update the quantity
						Cart.updateLine({
							line: {
								internalid: lineID,
								quantity: itemQuantity
							}
						});
					};

					//III B) IF NOT YET IN THE CART, add current item and quantity to the cart

					if (lineAlreadyExists == false) {
						Cart.addLine({
							line: {
								quantity: itemQuantity,
								item: {
									internalid: itemID
								}
							}
						});
					}
				});

			}, 500)




			, getContext: function getContext() {
				var itemInfo = this.contextData.item();
				//console.log('itemInfo: ', itemInfo)

				return {
					itemid: itemInfo.internalid,
					onlinecustomerprice: itemInfo.onlinecustomerprice,
					quantity: this.quantity
				};
			}
		});
	});



	//APPENDIX: EXTENSION SCRAPYARD
	// // @module Anchorgroup.GridCartAdder.GridCartAdderMod
// define('Anchorgroup.GridCartAdder.GridCartAdderMod.Populate'
//     , [
//         'anchorgroup_gridcartadder_populate.tpl'
//         , 'Utils'
//         , 'Backbone'
//         , 'jQuery'
//         , 'underscore'
//     ]
//     , function (
//         anchorgroup_gridcartadder_populate_tpl
//         , Utils
//         , Backbone
//         , jQuery
//         , _
//     ) {
//         'use strict';
//         var self

//         return Backbone.View.extend({

//             template: anchorgroup_gridcartadder_populate_tpl,
//             contextDataRequest: ['item']

//             , initialize: function (options) {
//                 console.log("GRID CART ADDER: POPULATE View Initiated: ", this.options);
//                 self = this;

//                 //I) Get an array of all the CART item IDs
//                 var Cart = this.options.container.getComponent('Cart');
//                 Cart.getLines().then(function (lines) {
//                     console.log(lines, lines.length);

//                     var masterArray = [];
//                     var quantity_SubtotalArray = [];
//                     var cartIDArray = [];
//                     for (var i = 0; i < lines.length; i++) { //BEGIN LOOP

//                         var itemID = JSON.stringify(lines[i]['item']['internalid']);

//                         cartIDArray.push(itemID);
//                     } //END LOOP



//                     console.log('cartIDArray: ', cartIDArray);
//                     masterArray.push(cartIDArray);


//                     //II) Get an array of all the div item IDs
//                     var itemIDArray = [];
//                     $("div[class='facets-item-cell-list']").each(function () {
//                         //console.log(this);
//                         var itemID = this.getAttribute('data-item-id');//jQuery.parseJSON()
//                         itemIDArray.push(itemID);

//                         //jQuery(this).attr("id", itemID);

//                     });

//                     console.log('itemIDArray: ', itemIDArray);
//                     masterArray.push(itemIDArray);
//                     console.log('masterArray: ', masterArray);

//                     //III) Get an array of all matches
//                     var filteredArray = masterArray.reduce((p, c) => p.filter(e => c.includes(e)));
//                     console.log('filteredArray: ', filteredArray);


//                     //IV) Loop through the arrays and get and set the quantities and subtotals
//                     for (var i = 0; i < filteredArray.length; i++) { //BEGIN LOOP
//                         //A) Select the divs
//                         var dataItemID = filteredArray[i];
//                         console.log('dataItemID: ', dataItemID);

//                         var div = $('#quantity-' + dataItemID);
//                         console.log('div iteration ' + i, div);


//                         //B) Get the quantity and subtotal
//                         var itemID = JSON.stringify(lines[i]['item']['internalid']);
//                         if (dataItemID == itemID) {
//                             console.log('itemID: ', itemID);

//                             var itemQuantity = lines[i]['quantity'];
//                             console.log('itemQuantity: ', itemQuantity);

//                             var itemRate = document.getElementById('quantity-' + itemID).getAttribute('data-rate');
//                             console.log('itemRate: ', itemRate);

//                             var subtotalAmount = itemQuantity * itemRate
//                             console.log('subtotalAmount: ', subtotalAmount);

//                             //C) Set the quantity
//                             jQuery(div).attr("value", itemQuantity);

//                             //D) Validate the content of the subtotal and set it

//                             var subtotalDiv = document.getElementById("subtotal-" + itemID);
//                             console.log('subtotalDiv: ', subtotalDiv);
//                             subtotalFormatAndSetter(subtotalDiv);

//                         }


//                     } //END LOOP


//                     //Defined functions
//                     function subtotalFormatAndSetter(subtotalDiv) {
//                         var decimalRegex = /[.]/;
//                         var currencyRegex = /[\$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/


//                         var decimalValidation = decimalRegex.test(subtotalAmount);
//                         console.log('decimalValidation: ', decimalValidation);
//                         var currencyValidation = currencyRegex.test(subtotalAmount);
//                         console.log('currencyValidation: ', currencyValidation);


//                         if (currencyValidation == false && decimalValidation == false) {
//                             jQuery(subtotalDiv).text('$' + subtotalAmount + '.00');

//                         } else if (currencyValidation == false && decimalValidation == true) {
//                             jQuery(subtotalDiv).text('$' + subtotalAmount);

//                         } else if (currencyValidation == true && decimalValidation == false) {
//                             jQuery(subtotalDiv).text(subtotalAmount + '.00');

//                         } else {
//                             jQuery(subtotalDiv).text(subtotalAmount);
//                         }
//                     }

//                 });
//             }


//             , getContext: function getContext() {

//                 return {
//                 };
//             }
//         });
//     });
